import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'FileShredderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-shredder",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 12l18 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 16l0 2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 16l0 6"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 16l0 2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 16l0 4"
    }, null), _createTextVNode(" ")]);
  }
};